import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const MenuLoginContainer = styled.div`
  opacity: 0;
  position: relative;
  z-index: 1;
`;

export default withAnimation(MenuLoginContainer);
